///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Namespaces
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.consumer_rfp = abcsetup.consumer_rfp || {};
abcsetup.consumer_rfp.humana = abcsetup.consumer_rfp.humana || {};

///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Methods
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.consumer_rfp.humana.common = {
    formBuilder: null,

    init() {
        // Init CKEditor
        $('textarea.ckeditor').toArray().forEach(element => CKEDITOR.create(element, CKEDITOR.config));

        // this._setupFormBuilder();
    },

    setupEventBindings() {
        // Update item sub lists when items list changes
        $('#app_a_b_c_item__item_ids,#app_models_consumer_r_f_p_item__custom_item_descriptions').on('change', () => {
            // this._syncItemSetupDeadlines();
            // this._syncItemInventoryDeadlines();
            // this._syncAnnualPurchaseQuantities();
            // this._syncEstimatedUpcomingVolumes();
            // this._syncActiveIngredients();
        }).trigger('change');

        // Toggle disabled on supplier selects when all suppliers checked or unchecked.
        $('#app_models_consumer_r_f_p__all_suppliers').on('change', event => {
            $('#app_models_consumer_r_f_p_supplier__supplier_ids')
                .toggleClass('disabled', $(event.target).prop('checked'))
                .attr('disabled', $(event.target).prop('checked'));
            $('#all_suppliers_sel').val($(event.target).prop('checked'));
        }).trigger('change');

        // Toggle custom fields visibility
        // $('#app_models_consumer_r_f_p__consumer_rfp_type_id').on('change', event => {
        //     const customFields = $('#custom_fields');
        //     customFields.toggle(customFields.data('typesAllowCustomFields')[event.target.value]);
        // }).trigger('change');

        // Open the item search window when the search button is pressed.
        $(document).on('click', '.btn-item-selector', () => abcsetup.launchWin('/consumer_rfp/item/item_selector', 'item_selector'));

        // Handle submit
        $(document).on('submit', '.consumer_rfp_form', () => {
            // Capture custom fields if necessary
            // $('#custom_fields > .fields_data').val(JSON.stringify(this.formBuilder.actions.getData()));
        });
    },

    /**
     * Process an import of suppliers.
     *
     * @param {{key:int, label:string}[]} suppliers
     */
    importSuppliers(suppliers) {
        if (!suppliers.length) {
            abcsetup.alerts.show('No suppliers found', '<div class="alert alert-danger text-center">No suppliers were found in the specified import file</div>');
            return;
        }

        this.appendSuppliers(suppliers);

        abcsetup.alerts.show('Supplier import', '<div class="alert alert-success text-center"><b>' + suppliers.length + ' suppliers</b> were successfully imported</div>');
    },

    /**
     * Append suppliers to the invited existing suppliers list.
     *
     * @param {{key:int, label:string}[]} suppliers
     */
    appendSuppliers(suppliers) {
        if ($('#app_models_consumer_r_f_p__all_suppliers').prop('checked')) {
            $('#app_models_consumer_r_f_p__all_suppliers').prop('checked', false).trigger('change');
        }

        $('#app_models_consumer_r_f_p_supplier__supplier_ids')
            .val(suppliers.map(supplier => supplier.key))
            .trigger('change');
    },

    /**
     * Process an import of items.
     *
     * @param {{key:int, label:string}[]} items
     * @param {{abc_item_id:int, ...}[]} extras
     */
    importItems(items, extras) {
        if (!items.length) {
            abcsetup.alerts.show('No items found', '<div class="alert alert-danger text-center">No items were found in the specified import file</div>');
            return;
        }

        this.appendItems(items, extras);

        abcsetup.alerts.show('Item import', '<div class="alert alert-success text-center"><b>' + items.length + ' items</b> were successfully imported</div>');
    },

    /**
     * Append items to the items up for bid list.
     *
     * @param {{key:int, label:string}[]} items
     * @param {{abc_item_id:int, ...}[]} extras
     */
    appendItems(items, extras) {
        const itemsSelect = $('#app_a_b_c_item__item_ids');

        items.forEach(item => {
            // Toggle the existing item or add it
            if (itemsSelect.find(`option[value=${item.key}]`).length) {
                itemsSelect.find(`option[value=${item.key}]`).prop('selected', true);
            } else {
                const newOption = new Option(item.label, String(item.key), true, true);
                itemsSelect.append(newOption);
            }
        });

        itemsSelect.trigger('change');

        const itemSetupDeadlineTable = $('#item_setup_deadline_table');
        const itemInventoryDeadlineTable = $('#item_inventory_deadline_table');
        const annualPurchaseQuantityTable = $('#annual_purchase_quantity_table');
        const estimatedUpcomingVolumeTable = $('#estimated_upcoming_volume_table');
        const activeIngredientTable = $('#active_ingredient_table');
        extras.forEach(extra => {
            itemSetupDeadlineTable.find(`tr.consumer_rfp_item_real_${extra.abc_item_id} input`).val(extra.item_setup_deadline_date).trigger('change');
            itemInventoryDeadlineTable.find(`tr.consumer_rfp_item_real_${extra.abc_item_id} input`).val(extra.item_inventory_deadline_date).trigger('change');
            annualPurchaseQuantityTable.find(`tr.consumer_rfp_item_real_${extra.abc_item_id} input`).val(extra.annual_purchase_quantity_value).trigger('change');
            estimatedUpcomingVolumeTable.find(`tr.consumer_rfp_item_real_${extra.abc_item_id} input`).val(extra.estimated_upcoming_volume_value).trigger('change');
            activeIngredientTable.find(`tr.consumer_rfp_item_real_${extra.abc_item_id} input`).val(extra.active_ingredient_value).trigger('change');
        });
    },

    /**
     * Delete an item from the humana_import_item table, e.g. the CM does not want to create
     * a bid event from this item.
     *
     * @param int humana_import_item_id
     * @param string product_description
     */
    deleteHumanaImportItem(humana_import_item_id,product_description,goto_dashboard) {
        abcsetup.alerts.confirm(
                `Ignore Large Customer Bid Item: ${product_description}`,
                `<div class="alert alert-info"><p>This item will be ignored, and an RFQ event will not be created. It is required that you provide a reason as to why you do NOT want to create an RFQ event for this item.</p>
                <p><label>Please select a reason below by clicking the checkbox next to your reason: </label>
                <div id="ignore_reasons">
                    <div class="checkbox px-2">
                        <label>
                            <input type="checkbox" id="ignore_reason[]" name="ignore_reason[]" class="form-check-input" value="Not Correct Match">
                            Not Correct Match
                        </label>
                    </div>
                    <div class="checkbox px-2">
                        <label>
                            <input type="checkbox" id="ignore_reason[]" name="ignore_reason[]" class="form-check-input" value="Another CM is handling">
                            Another CM is handling
                        </label>
                    </div>
                    <div class="checkbox px-2">
                        <label>
                            <input type="checkbox" id="ignore_reason[]" name="ignore_reason[]" class="form-check-input" value="No Available Supply">
                            No Available Supply
                        </label>
                    </div>
                    <div class="checkbox px-2">
                        <label>
                            <input type="checkbox" id="ignore_reason[]" name="ignore_reason[]" class="form-check-input" value="Not a standard product that we would carry in our DC's">
                            Not a standard product that we would carry in our DC's
                        </label>
                    </div>
                    <div class="checkbox px-2">
                        <label>
                            <input type="checkbox" id="ignore_reason[]" name="ignore_reason[]" class="form-check-input" value="Other" onchange="">
                            Other
                        </label>

                        <textarea name="ignore_reason_other" id="ignore_reason_other" class="form-control reject-description ml-4 pr-3" placeholder="Additional information" rows="3"></textarea>
                    </div>
                </div>`,
        function (resp) {
            if (resp) {
                abcsetup.blockUI(true);
                var checked_reasons = $("#ignore_reasons").find('input[name="ignore_reason[]"]:checked');
                if (checked_reasons.length == 0) {
                    abcsetup.alerts.show('Ignore Error', 'Please select at least 1 reason to ignore the Humana Item');
                    return false;
                }
                if ($("#ignore_reasons").find("input[name='ignore_reason[]'][value='Other']").prop("checked")) {
                    if (!$("#ignore_reasons").find("#ignore_reason_other").val()) {
                        abcsetup.alerts.show('Ignore Error', 'Please enter the other reason comment');
                        return false;
                    }
                }

                var reasonArr = [];

                $("#ignore_reasons").find('input[name="ignore_reason[]"]:checked').each(function() {
                    if (this.value == 'Other') {
                        reasonArr.push(this.value+': '+$("#ignore_reasons").find("#ignore_reason_other").val());
                    }
                    else {
                        reasonArr.push(this.value);
                    }
                });

                const ignore_reasons = {
                    reason: reasonArr.toString(),
                };
                axios.delete('/api/humana/item/' + humana_import_item_id, {data: ignore_reasons}).then(response => {
                    if(!response.data.error) {
                        $('#rfp_humana_item_import_in_review .datatable').DataTable().ajax.reload();
                        abcsetup.alerts.flashMessage(response.data.message);

                        if (goto_dashboard) {
                            window.location.href='/dashboard';
                        }

                    } else {
                        abcsetup.alerts.flashMessage('An error occurred: ' + response.data.error, 'error');
                    }
                    abcsetup.unblockUI();
                })
                .catch((error) => {
                    abcsetup.unblockUI();
                });
            }
        });

        // ignore reason Other event handler
        $(document).on('change', "input[name='ignore_reason[]'][value='Other']", function(event) {
            $("#ignore_reason_other").toggle();
        });
    },

    /**
     * Update the item setup deadline table
     */
    _syncItemSetupDeadlines() {
        this._syncItemMetaDataTable($('#item_setup_deadline_table'), 'item_setup_deadline');
    },

    /**
     * Update the item inventory deadline table
     */
    _syncItemInventoryDeadlines() {
        this._syncItemMetaDataTable($('#item_inventory_deadline_table'), 'item_inventory_deadline');
    },

    /**
     * Update the item annual purchase quantities table.
     */
    _syncAnnualPurchaseQuantities() {
        this._syncItemMetaDataTable($('#annual_purchase_quantity_table'), 'annual_purchase_quantity', false);
    },

    /**
     * Update the item estimated upcoming volumes table.
     */
    _syncEstimatedUpcomingVolumes() {
        this._syncItemMetaDataTable($('#estimated_upcoming_volume_table'), 'estimated_upcoming_volume', false);
    },

    /**
     * Update the item active ingredient table.
     */
    _syncActiveIngredients() {
        this._syncItemMetaDataTable($('#active_ingredient_table'), 'active_ingredient', false);
    },

    /**
     * Sync the rows in the given table with the items selected in the real items input.
     *
     * @param table
     * @param fieldName
     * @param defaultToExistingValue
     * @private
     */
    _syncItemMetaDataTable(table, fieldName, defaultToExistingValue = true) {
        const originals = table.data('originals') || {};
        // This is the value we'll copy to new items that we don't already have values for.
        const defaultValue = defaultToExistingValue ? table.find(':input').toArray().map(field => field.value).filter(Boolean).shift() : null;
        // Update the original values we have for items that were stored in the database when this page was built.
        const updateOriginals = (key, val) => {
            originals[key] = val;
            table.data('originals', originals);
        };
        // Add an item row to this table.
        const appendRow = (itemDescription, val, className, rowFieldName) => {
            const template = table.find('.template');
            const newRow = template.clone().removeClass('collapse template').addClass(className);
            newRow.find('.description').text(itemDescription);
            newRow.find('.value input').val(val).attr('name', rowFieldName);
            table.append(newRow);
        }

        // Sync the real items dropdown.
        $('#app_a_b_c_item__item_ids').val().forEach(ABCItemId => {
            const consumerRFPItemId = table.data('abcItemToConsumerRfpItemId')[ABCItemId];
            const type = 'real';
            const id = ABCItemId;
            const originalsKey = consumerRFPItemId || `${type}_${id}`
            const className = `consumer_rfp_item_${type}_${id}`;

            if (table.find(`tr.${className}`).length) {
                table.find(`tr.${className}`).addClass('valid');
                return;
            }

            const description = $('#app_a_b_c_item__item_ids option[value=' + ABCItemId + ']').text();
            const val = originals[originalsKey] || defaultValue;

            updateOriginals(originalsKey, val);
            appendRow(description, val, className, `${fieldName}[${type}][${id}]`);
        });

        $('#app_models_consumer_r_f_p_item__custom_item_descriptions').val().forEach(itemDescription => {
            const consumerRFPItemId = table.data('descriptionToConsumerRfpItemId')[itemDescription];
            const type = 'custom';
            const id = itemDescription;
            const originalsKey = consumerRFPItemId || `custom_${id}`
            // As a part of this, we're converting the item description (if working with one) to something CSS is happy with.
            const className = `consumer_rfp_item_${type}_${btoa(id).replace(/[^0-9A-Za-z_]/g, '_')}`;

            if (table.find(`tr.${className}`).length) {
                table.find(`tr.${className}`).addClass('valid');
                return;
            }

            const val = originals[originalsKey] || defaultValue;

            updateOriginals(originalsKey, val);
            appendRow(itemDescription, val, className, `${fieldName}[${type}][${id}]`);
        });

        table.find('tbody tr:not(.valid)').remove();
        table.find('tbody tr:not(.template)').removeClass('valid');
    },

    // _setupFormBuilder() {
    //     this.formBuilder = $('#custom_fields .form_builder').formBuilder({
    //         scrollToFieldOnAdd: false,
    //         formData: JSON.parse($('#custom_fields > .fields_data').val()),
    //         disabledActionButtons: ['clear', 'data', 'save'],
    //         disableFields: ['hidden', 'file', 'button'],
    //         disabledAttrs: [
    //             'access',
    //             'className',
    //             'name',
    //         ],
    //         disabledSubtypes: {
    //             textarea: ['tinymce', 'quill'],
    //         },
    //     });
    // }
};
